import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { DetailsItem } from 'components';
import { useOpenable } from 'hooks';
import IPosition from 'types/Position';
import { executeFunctionsCurried } from 'utils/functionUtils';
import { t } from 'utils/localize';
import PositionDetailsActivityReportForm, {
  IPositionDetailsActivityReportFormProps,
} from '../forms/PositionDetailsActivityReportForm';
import { positionsValueString } from '../util/util';

export interface IPositionDetailsActivityReportDetailProps
  extends Omit<IPositionDetailsActivityReportFormProps, 'onSubmit' | 'subtitle' | 'positionId'> {
  position: IPosition;
  editable: boolean;
  onUpdate: () => Promise<void>;
}

function PositionDetailsActivityReportDetail({
  onUpdate,
  editable,
  className,
  position,
  ...formProps
}: IPositionDetailsActivityReportDetailProps) {
  const dialogOpenable = useOpenable();

  const subtitle = position.viewAllActivityReport
    ? t('Everyone (All Activity Reports)')
    : positionsValueString(position.viewMemberActivityReport ?? 0) + ' ' + t('(Mobile Employees Report Only)');

  return (
    <>
      <DetailsItem
        className={classNames('position-details-activity-report-detail', className)}
        title={t('View Activity Reports for') + ':'}
        onClick={dialogOpenable.open}
        disabled={!editable}
        value={subtitle}
      />
      <Dialog position={'center'} isOpen={dialogOpenable.isOpen} onClose={dialogOpenable.close}>
        <PositionDetailsActivityReportForm
          className="mt-4 p-8"
          position={position}
          onSubmit={executeFunctionsCurried(onUpdate, dialogOpenable.close)}
          {...formProps}
        />
      </Dialog>
    </>
  );
}

export default PositionDetailsActivityReportDetail;
